import React from 'react';
import {formatPurchaseDisclosure} from '../../helpers';

export default function PurchaseDisclosure({plan, amountDueNow}) {
    const disclosure = formatPurchaseDisclosure(plan, amountDueNow);
    if (!disclosure) return null;

    return (
        <aside aria-label="Subscription terms" className="mar-b-1 mar-t-1">
            <strong>Subscription terms: </strong>{disclosure}{' '}
            Read the <a href="https://plucking.app/tos" target="_blank" rel="noreferrer">Terms of Service</a>
            {' '}and <a href="https://plucking.app/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a>.
        </aside>
    );
}
